import { define } from 'wicked-elements'

define('[data-component~="contact-form"]', {
  init () {
    this.$form = this.element
    this.$status = this.element.querySelector('[data-status]')
    this.$button = this.element.querySelector('[data-button]')
    this.handleSubmit = this.handleSubmit.bind(this)
  },
  connected () {
    this.element.addEventListener('submit', this.handleSubmit)
  },
  disconnected () {
    this.element.removeEventListener('submit', this.handleSubmit)
  },
  async handleSubmit (event) {
    event.preventDefault()
    this.$button.innerHTML = 'Submitting…'
    var data = new FormData(event.target)
    fetch(event.target.action, {
      method: this.$form.method,
      body: data,
      headers: {
        'Accept': 'application/json'
      }
    }).then(response => {
      this.$status.innerHTML = 'Thanks for your submission!'
      this.$button.innerHTML = 'Submit'
      this.$form.reset()
    }).catch(error => {
      this.$status.innerHTML = 'Oops! There was a problem submitting your form'
      this.$button.innerHTML = 'Submit'
    })
  }
})